import { render } from "./CartFile.vue?vue&type=template&id=2b5d879d&scoped=true"
import script from "./CartFile.vue?vue&type=script&lang=ts"
export * from "./CartFile.vue?vue&type=script&lang=ts"

import "./CartFile.vue?vue&type=style&index=0&id=2b5d879d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b5d879d"

export default script